import { render, staticRenderFns } from "./Gaia.vue?vue&type=template&id=3dc7f666&scoped=true"
import script from "./Gaia.vue?vue&type=script&lang=js"
export * from "./Gaia.vue?vue&type=script&lang=js"
import style0 from "./Gaia.vue?vue&type=style&index=0&id=3dc7f666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7f666",
  null
  
)

export default component.exports